// extracted by mini-css-extract-plugin
export default {"outer_container":"_3r1U","container":"_2NTz","sandbox":"_3v6Z"};